<template lang="pug">
  v-app
    a.skip-link(href="#main-content") Skip to main content
    v-app-bar(flat app height="60" style="background-color: #005cb8; " tag="header" aria-label="Site")
      a.d-flex.align-center.px-4(href="https://arlingtonva.us" style="height: 100%" aria-label="Arlington County, Virginia — home")
        v-img(src="/images/CountyLogo_Reverse_Horizontal.png" max-width="200" contain alt="")

      div(style="position: absolute; left: 50%; transform: translateX(-50%);")
        router-link.white--text.text-decoration-none(:to="{ name: 'vpp' }" :aria-current="$route.name === 'vpp' ? 'page' : null")
          span.font-weight-medium.text-h6.d-none.d-sm-flex Vehicle Personal Property Tax Estimator

    v-main#main-content(tabindex="-1")
      router-view

    v-footer(color="#005cb8" tag="footer" role="contentinfo")
      p.ma-auto.white--text.body-2 Copyright © {{ new Date().getFullYear() }} Arlington County Virginia
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    links: [
      { title: "Example Link", url: "https://arlingtonva.us" }
    ]
  }),
};
</script>

<style lang="stylus">
.no-decoration
  text-decoration: none

.skip-link
  position: absolute
  left: -9999px
  top: 0
  z-index: 200
  padding: 12px 16px
  background: #fff
  color: #000
  font-weight: 600
  text-decoration: none
  border: 2px solid #005cb8

.skip-link:focus
  left: 8px
  top: 8px
  outline: 3px solid #ffc107
  outline-offset: 2px
</style>
